export function successToast(toast, message, clearAll) {
    if (clearAll) {
        toast.removeAllGroups();
    }
    toast.add({
        severity: 'success',
        summary: 'Successful',
        detail: message,
        life: 10000,
    });
}

export function failureToast(toast, msg = '') {
    msg = msg || 'There was a problem fetching the response.';
    toast.removeAllGroups();
    toast.add({
        severity: 'error',
        summary: 'Error',
        detail: msg,
        life: 10000,
    });
}

export function warningToast(toast, msg) {
    toast.add({
        severity: 'warn',
        summary: 'Warning',
        detail: msg,
        life: 10000,
    });
}
